import { ControlledSelect } from "@dune/ui";
import { useFormContext } from "react-hook-form";
import { useGetInsurerSocieties } from "../../api/queries/societies.queries";
import { AddOrUpdateContactFormModeProps } from "./ContactForm";
import { ContactFormData } from "./useAddContactForm";

export const InsurerContactForm = ({
	mode,
}: AddOrUpdateContactFormModeProps) => {
	const formMethods = useFormContext<ContactFormData>();
	const {
		control,
		formState: { errors },
	} = formMethods;

	const { data: insurerSocieties } = useGetInsurerSocieties();

	return (
		<>
			<ControlledSelect
				control={control}
				name="insurerSocietyId"
				label="Société"
				options={insurerSocieties?.map((insurerSociety) => ({
					label: insurerSociety.denomination,
					value: insurerSociety.id,
				}))}
				placeholder="Sélectionner"
				error={errors.insurerSocietyId?.message}
				required
				disabled={mode === "update"}
			/>
		</>
	);
};
